import { Tabs, TabsProps } from "antd";
import { CreateButton, List } from "@refinedev/antd";
import { useNavigation } from "@refinedev/core";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { EmployeeList } from "./EmployeeList";
import { DepartmentsList } from "./DepartmentsList";

export const FNLTeam = () => {
  const navigate = useNavigate();
  const { push } = useNavigation();

  const [searchParams] = useSearchParams();
  const tabKey = searchParams.get("tab") || "employee";

  const onChange = (key: string) => {
    navigate(
      {
        search: createSearchParams({
          tab: key,
        }).toString(),
      },
      {
        replace: true,
      }
    );
  };

  const items: TabsProps["items"] = [
    {
      key: "employee",
      label: "Сотрудники",
      children: <EmployeeList />,
    },
    {
      key: "deps",
      label: "Департаменты",
      children: <DepartmentsList />,
    },
  ];

  const handleNavigateToCreateEmployee = () => {
    push("/league-info/employees/team/create-employee");
  };
  const handleNavigateToCreateDept = () => {
    push("/league-info/employees/team/create-dept");
  };

  return (
    <List
      title="Команда ФНЛ"
      resource={"employees"}
      breadcrumb={false}
      canCreate={false}
      wrapperProps={{ style: { position: "sticky", top: 24 } }}
      headerButtons={
        <>
          <CreateButton onClick={() => handleNavigateToCreateEmployee()}>
            Добавить сотрудника
          </CreateButton>
          <CreateButton onClick={() => handleNavigateToCreateDept()}>
            Добавить департамент
          </CreateButton>
        </>
      }
    >
      <Tabs items={items} onChange={onChange} activeKey={tabKey} />
    </List>
  );
};
